module.exports = __webpack_public_path__ + "static/media/icon_renew.bf30555b.svg";